import { render, staticRenderFns } from "./WebPartner.vue?vue&type=template&id=62853177&scoped=true"
import script from "./WebPartner.vue?vue&type=script&lang=js"
export * from "./WebPartner.vue?vue&type=script&lang=js"
import style0 from "./WebPartner.vue?vue&type=style&index=0&id=62853177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62853177",
  null
  
)

export default component.exports